import Slide from '@/mixins/Slide'

export default
{
    mixins: [
        Slide
    ],

    data()
    {
        return {
            isOver: false
        }
    },

    computed:
    {
        content()
        {
            return this.$store.slide09
        }
    }
}
